"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewportSize = void 0;
const react_1 = require("react");
const Responsive_1 = require("../ds/shared/Responsive");
const useMediaQuery_1 = require("./useMediaQuery");
/**
 * Gets the greatest breakpoint that the size of the viewport currently matches.
 *
 * Mapping devices to breakpoints:
 * - mobile: xs, sm
 * - tablet: md
 * - desktop: lg, xl
 */
const useViewportSize = () => {
    // Adding a check for windows before proceeding this is due to Patient portal Next JS server side rendering feature where window var is unavailable on the server
    if (typeof window === "undefined")
        return { size: "xs" };
    const [sm, md, lg, xl] = [
        (0, useMediaQuery_1.useMediaQuery)(Responsive_1.breakpointMedia.sm),
        (0, useMediaQuery_1.useMediaQuery)(Responsive_1.breakpointMedia.md),
        (0, useMediaQuery_1.useMediaQuery)(Responsive_1.breakpointMedia.lg),
        (0, useMediaQuery_1.useMediaQuery)(Responsive_1.breakpointMedia.xl),
    ];
    return (0, react_1.useMemo)(() => {
        if (xl)
            return { size: "xl" };
        if (lg)
            return { size: "lg" };
        if (md)
            return { size: "md" };
        if (sm)
            return { size: "sm" };
        return { size: "xs" };
    }, [sm, md, lg, xl]);
};
exports.useViewportSize = useViewportSize;
//# sourceMappingURL=useViewportSize.js.map